import React, { Component } from 'react';

class Footer extends Component {
	render() {
		return (
			<div className="footer">
				<p>Penned over&nbsp;
					<i className="fa fa-coffee"></i>&nbsp;
					by <a href="https://www.linkedin.com/in/adarshlilha/LavanyaRavi22">Lala</a> & <a href="https://www.linkedin.com/in/adarshlilha/">Lilha</a>
					&nbsp;
				    <i className="fa fa-at"></i>
				    &nbsp;Jaaga Study Q4,2017&nbsp;
				    <i className="fa fa-leaf"></i>
				</p>
			</div>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js